/**
 * Update domain scores in a table
 * @param {string} tableId - ID of the table to update
 * @param {Object} scoresByPrefix - Scores organized by prefix
 */
function updateDomainScoresInTable(tableId, scoresByPrefix) {
	// console.log(`[updateDomainScoresInTable] Called with tableId: ${tableId}, scoresByPrefix:`, scoresByPrefix);
	const table = document.getElementById(tableId);
	if (!table) {
		// console.error(`[updateDomainScoresInTable] Table with ID '${tableId}' not found.`);
		return;
	}

	const tbody = table.getElementsByTagName('tbody')[0];
	if (!tbody) {
		// console.error(`[updateDomainScoresInTable] tbody not found in table '${tableId}'.`);
		return;
	}

	// Reset all scores in the table to 0.00 first to clear old values
	for (let i = 0; i < tbody.rows.length; i++) {
		const row = tbody.rows[i];
		if (row.cells.length > 1) {
			row.cells[1].textContent = '0.00';
		}
	}

	let totalScoreForOverall = 0;
	let countForOverall = 0;

	for (const prefix in scoresByPrefix) {
		if (scoresByPrefix.hasOwnProperty(prefix)) {
			const scoreData = scoresByPrefix[prefix];
			const fullDomainTitle = window.prefixToDomainTitles(prefix);
			let foundRow = false;

			for (let i = 0; i < tbody.rows.length; i++) {
				const row = tbody.rows[i];
				if (row.cells.length > 1) {
					const cellTitle = row.cells[0].textContent.trim();
					if (cellTitle === fullDomainTitle) {
						const averageScore = parseFloat(scoreData.averageScore).toFixed(2);
						row.cells[1].textContent = averageScore;
						if (!isNaN(parseFloat(averageScore))) {
							totalScoreForOverall += parseFloat(averageScore);
							countForOverall++;
						}
						foundRow = true;
						// console.log(`[updateDomainScoresInTable] Updated ${fullDomainTitle} (${prefix}) score to ${averageScore}`);
						break; 
					}
				}
			}
			if (!foundRow) {
				// console.warn(`[updateDomainScoresInTable] No matching row found in table '${tableId}' for domain title: '${fullDomainTitle}' (prefix: '${prefix}')`);
			}
		}
	}

	// Update Overall Score
	const overallCellSelector = `.crf-domain-overall, .crf-legacy-domain-overall`; // General selectors for overall
	const overallCell = table.querySelector(overallCellSelector) || (table.tFoot ? table.tFoot.querySelector('strong') : null);

	if (overallCell) {
		const overallAverage = countForOverall > 0 ? (totalScoreForOverall / countForOverall).toFixed(2) : '0.00';
		overallCell.textContent = overallAverage;
		// console.log(`[updateDomainScoresInTable] Updated overall score to ${overallAverage}`);
	}
}

// Export for use in other modules
if (typeof module !== 'undefined' && module.exports) {
	module.exports = updateDomainScoresInTable;
} else if (typeof window !== 'undefined') {
	window.updateDomainScoresInTable = updateDomainScoresInTable;
}
